import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/invoice-item";

export const pageOrder = (voucher) =>
  axios.post(API_PATH + "/search-by-page", voucher);

export const updateNotPaymentRequriedStatus = (items) =>
  axios.post(API_PATH + "/update-not-payment-requried", items);
export const updateCancelDebitItem = (items) =>
  axios.post(API_PATH + "/update-cancel-debit-item", items);
export const getListInvoiceItemByInsurance = (items) =>
  axios.post(API_PATH + "/get-list-invoice-item-by-insurance", items);
export const updateUseInsByListItem = (items) =>
  axios.post(API_PATH + "/update-use-ins-by-list-item", items);
export const getInvoiceItemByType = (items) =>
  axios.post(API_PATH + "/get-invoice-item-by-type", items);

export const exportExcelRevenueAllocationReport = (obj) => {
  let url = API_PATH + "/export-excel-revenue-allocation-report";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportExcelSalesReport = (obj) => {
  let url = API_PATH + "/export-excel-sales-report";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportAccountsDebt = (obj) => {
  let url = API_PATH + "/export-excel-accounts-debt-report";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportSummaryOrderReport = (obj) => {
  let url = API_PATH + "/export-excel-summary-order-report";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const lockOrder = (items) => axios.post(API_PATH + "/lock-order", items);
